// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1oK1y","dadosUsuario":"OptionSelect_dadosUsuario__2_B9K","focado":"OptionSelect_focado__3RNN6"};